.poweredBySportRadar {
  display: none;
  flex-direction: column;
  gap: var(--cxy-spacing-1);
  margin-top: var(--cxy-spacing-4);
}
.poweredBySportRadar span {
  color: var(--cxy-color-content-default);
  font-size: var(--cxy-fontSize-m);
  line-height: var(--cxy-lineHeight-m);
  font-weight: var(--cxy-fontWeight-light);
}
.poweredBySportRadar img {
  width: 150px;
}
[data-fpsm-theme='gazzetta'] .poweredBySportRadar img {
  filter: brightness(0) saturate(100%);
}
@media (min-width: 801px) {
  .poweredBySportRadar {
    display: flex;
    gap: var(--cxy-spacing-2);
    flex-direction: row;
  }
  .poweredBySportRadar span {
    font-size: var(--cxy-fontSize-l);
    line-height: var(--cxy-lineHeight-l);
  }
  .poweredBySportRadar img {
    width: 175px;
  }
}
